export var TagsActionTypes;
(function (TagsActionTypes) {
    TagsActionTypes["FETCH_TAGS_ATTEMPT"] = "FETCH_TAGS_ATTEMPT";
    TagsActionTypes["FETCH_TAGS_SUCCESS"] = "FETCH_TAGS_SUCCESS";
    TagsActionTypes["FETCH_TAGS_FAILURE"] = "FETCH_TAGS_FAILURE";
    TagsActionTypes["SET_ACTIVE_TAG"] = "SET_ACTIVE_TAG";
})(TagsActionTypes || (TagsActionTypes = {}));
